<template>
    <div v-if="loader" style="height: 250px; line-height: 250px;">
        <v-progress-circular indeterminate :size="50"></v-progress-circular>
    </div>
    <div v-else class="row ma-4" style="width: 70%;">
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.firstName') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="firstName" id="firstName" name="firstName" maxlength="30" hide-details
                    persistent-placeholder variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : ''"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.firstName')]"
                    @change="valuesToCorrect($t('clients.generalInformation.firstName'), checkboxStates[$t('clients.generalInformation.firstName')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.lastName') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="lastName" id="lastName" name="lastName" maxlength="30" hide-details
                    persistent-placeholder variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.lastName')]"
                    @change="valuesToCorrect($t('clients.generalInformation.lastName'), checkboxStates[$t('clients.generalInformation.lastName')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.licenseNumber') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="patentNum" id="licenseNumber" name="licenseNumber" hide-details
                    persistent-placeholder maxlength="20" variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.licenseNumber')]"
                    @change="valuesToCorrect($t('clients.generalInformation.licenseNumber'), checkboxStates[$t('clients.generalInformation.licenseNumber')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.phone') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="phoneNumber" id="phone" name="phone" hide-details persistent-placeholder
                    maxlength="20" variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.phone')]"
                    @change="valuesToCorrect($t('clients.generalInformation.phone'), checkboxStates[$t('clients.generalInformation.phone')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.companyName') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="nomSocial" id="companyName" name="companyName" hide-details
                    persistent-placeholder maxlength="20" variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.companyName')]"
                    @change="valuesToCorrect($t('clients.generalInformation.companyName'), checkboxStates[$t('clients.generalInformation.companyName')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.typeOfBusiness')
                    }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="typeActivity" id="typeOfBusiness" name="typeOfBusiness" hide-details
                    persistent-placeholder maxlength="20" variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.typeOfBusiness')]"
                    @change="valuesToCorrect($t('clients.generalInformation.typeOfBusiness'), checkboxStates[$t('clients.generalInformation.typeOfBusiness')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.city') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="city" id="city" name="city" hide-details persistent-placeholder maxlength="20"
                    variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.city')]"
                    @change="valuesToCorrect($t('clients.generalInformation.city'), checkboxStates[$t('clients.generalInformation.city')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.state') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="state" id="state" name="state" hide-details persistent-placeholder maxlength="20"
                    variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.state')]"
                    @change="valuesToCorrect($t('clients.generalInformation.state'), checkboxStates[$t('clients.generalInformation.state')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.address') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="address" id="address" name="address" hide-details persistent-placeholder
                    maxlength="20" variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.address')]"
                    @change="valuesToCorrect($t('clients.generalInformation.address'), checkboxStates[$t('clients.generalInformation.address')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.postalCode') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="codePostal" id="postalCode" name="postalCode" hide-details persistent-placeholder
                    maxlength="20" variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.postalCode')]"
                    @change="valuesToCorrect($t('clients.generalInformation.postalCode'), checkboxStates[$t('clients.generalInformation.postalCode')])">
                </v-checkbox>
            </div>
        </div>
        <div class="col-6 justify-content-start mb-4">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('clients.generalInformation.contactMethod') }}</v-card-title>
            </div>
            <div class="d-flex">
                <v-text-field v-model="mail" id="contactMethod" name="contactMethod" hide-details persistent-placeholder
                    maxlength="20" variant="outlined" :readonly="!canEdit"
                    :class="!canEdit ? 'readonly-field w-100' : 'w-100'"></v-text-field>
                <v-checkbox :class="(filterItemsFilter.includes(status)) ? 'd-none' : ''" style="color: #114ef7;" hide-details
                    v-model="checkboxStates[$t('clients.generalInformation.contactMethod')]"
                    @change="valuesToCorrect($t('clients.generalInformation.contactMethod'), checkboxStates[$t('clients.generalInformation.contactMethod')])">
                </v-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
import { getClientsById } from "@/api/index";

export default {
    data: () => ({
        loader: true,
        firstName: "",
        lastName: "",
        patentNum: "",
        phoneNumber: "",
        nomSocial: "",
        typeActivity: "",
        city: "",
        state: "",
        address: "",
        codePostal: "",
        filterItemsFilter:[1,3,4],
        mail: "",
        status:null,
        checkboxStates: {},
        canEdit: false
    }),
    created() {
        const clientId = this.$route.params.id;
        const storedArray = JSON.parse(localStorage.getItem(`toCorrect//${clientId}`)) || [];
        storedArray.forEach(name => {
            this.checkboxStates[name] = true;
        });
        this.getClientsById(clientId);
    },
    methods: {
        getClientsById(clientId) {
            this.loader = true;
            getClientsById(clientId)
                .then(response => {
                    const client = response.data;
                    this.firstName = client.firstName;
                    this.lastName = client.lastName;
                    this.patentNum = client.patentNum;
                    this.phoneNumber = client.phoneNumber;
                    this.nomSocial = client.nomSocial;
                    this.typeActivity = client.typeActivity;
                    this.status=client.accountStatus;
                    this.city = client.city;
                    this.state = client.state;
                    this.address = client.address;
                    this.codePostal = client.codePostal;
                    this.mail = client.mail;
                })
                .catch(error => {
                    console.error("Error fetching client details:", error);
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        valuesToCorrect(name, isSelected) {
            const clientId = this.$route.params.id;
            const storageKey = `toCorrect//${clientId}`;
            let array = JSON.parse(localStorage.getItem(storageKey)) || [];
            if (isSelected) {
                if (!array.includes(name)) {
                    array.push(name);
                }
            } else {
                array = array.filter(item => item !== name);

                if (array.length === 0) {
                    localStorage.removeItem(storageKey);
                    return;
                }
            }
            localStorage.setItem(storageKey, JSON.stringify(array));
        }
    }
};
</script>

<style scoped>
.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}
</style>